export var ClientType;
(function (ClientType) {
    ClientType["SPA"] = "spa";
    ClientType["S2S"] = "s2s";
})(ClientType || (ClientType = {}));
export var Scope;
(function (Scope) {
    Scope["OpenId"] = "openid";
    Scope["Profile"] = "profile";
    Scope["OfflineAccess"] = "offline_access";
    Scope["Root"] = "root";
    Scope["ReadUser"] = "read_user";
    Scope["WriteUser"] = "write_user";
    Scope["ReadApp"] = "read_app";
    Scope["WriteApp"] = "write_app";
    Scope["ReadRole"] = "read_role";
    Scope["WriteRole"] = "write_role";
    Scope["ReadScope"] = "read_scope";
    Scope["WriteScope"] = "write_scope";
    Scope["ReadOrg"] = "read_org";
    Scope["WriteOrg"] = "write_org";
})(Scope || (Scope = {}));
export var Role;
(function (Role) {
    Role["SuperAdmin"] = "super_admin";
})(Role || (Role = {}));
export var SessionStorageKey;
(function (SessionStorageKey) {
    SessionStorageKey["State"] = "melody-auth-state";
    SessionStorageKey["CodeVerifier"] = "melody-auth-code-verifier";
})(SessionStorageKey || (SessionStorageKey = {}));
export var StorageKey;
(function (StorageKey) {
    StorageKey["RefreshToken"] = "melody-auth-refresh-token";
    StorageKey["IdToken"] = "melody-auth-id-token";
})(StorageKey || (StorageKey = {}));
